// extracted by mini-css-extract-plugin
export default {"flags":"HUYxm8","flag":"zVTOug","active":"BwE2XP"};